/**
 * Created by anthony on 7/9/14.
 */
var baseModel = angular.module('baseModel', ['abstractModel']);
baseModel.factory('BaseModel', function(RestService, AbstractModelService, $q){
    var BaseModel = function(endpoint)
    {
        this.endpoint = endpoint;
    }
    BaseModel.prototype.resolveData = function (arg, headers)
    {
        var self = this;
        var deferred = $q.defer();
        $q.all([
                RestService.get(this.getEndpoint(arg, headers), headers),
            ]).then(function (results) {
                self.arg = arg;
                self.set(results[0].data);
                deferred.resolve(results);
            }, function(results) {
                window.location.href = "/";
            });
        return deferred.promise;
    }

    BaseModel.prototype.set = function(item)
    {
        if (typeof this.dataProperty === 'undefined')
        {
            this.data = angular.copy(item);
            this.origData = angular.copy(item);
        }
        else
        {
            this.data[this.dataProperty] = angular.copy(item);
            this.origData[this.dataProperty] = angular.copy(item);
        }
    }

    BaseModel.prototype.setIndex = function(item, index)
    {
        if (typeof this.dataProperty === 'undefined')
        {
            this.data[index] = angular.copy(item);
            this.origData[index] = angular.copy(item);
        }
        else
        {
            //this.data[index] = angular.copy(item, this.get());
            //this.data[this.dataProperty][index] = angular.copy(item);
        }
    }

    BaseModel.prototype.revertCopy = function()
    {
        this.data = angular.copy(this.origData);
    }

    BaseModel.prototype.isDirty = function() //Abstract
    {
        return !angular.equals(this.data, this.get());
    }


    BaseModel.prototype.get = function(arg, noResolve)
    {
        if (typeof arg == "undefined" && typeof this.origData !== 'undefined')
            return this.origData;
        else if ((typeof this.origData == 'undefined' && typeof noResolve == "undefined") || this.arg != arg )
            return this.resolveData(arg);
        return this.origData;
    }
    BaseModel.prototype.getEndpoint = function(args)
    {
        return "/api/" + this.endpoint + args;
    }
    BaseModel.prototype.put = function(id, data, instance)
    {
        if (typeof data[this.primaryKey] === 'undefined')
            return AbstractModelService.put(this.getEndpoint(id), data, instance);
        else
            return AbstractModelService.put(this.getEndpoint(id) + '/' + data[this.primaryKey], data, instance);
    }
    BaseModel.prototype.putMultiple = function(id, data, instance)
    {
        return AbstractModelService.put(this.getEndpoint(id), data, instance);
    }

    BaseModel.prototype.post = function(id, data, instance)
    {
        return AbstractModelService.post(this.getEndpoint(id), data, instance);
    }
    BaseModel.prototype.purge = function(id, data, instance)
    {
        return AbstractModelService.purge(this.getEndpoint(id) + '/' + data[this.primaryKey], data, instance);
    }
    return BaseModel;
});
